import React from 'react';
import { Snackbar, Alert } from '@mui/material';
import { Actions, useDispatchProvider, useStateSnackbar } from './StateProvider';

const SnackbarAlert = () => {
  const stateDrawerSnackbar = useStateSnackbar();
  const dispatch = useDispatchProvider();
  const toggleSnackbar = (newOpen) => () => {
    dispatch && dispatch({ type: Actions.Snackbar, payload: { open: newOpen } });
  };

  return (
    <Snackbar
      open={stateDrawerSnackbar.open}
      autoHideDuration={null}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      onClose={toggleSnackbar(false)}
      sx={{ top: 24, right: 24, left: 24, maxWidth: 'calc(100vw - 48px)' }}
    >
      <Alert
        onClose={toggleSnackbar(false)}
        severity={stateDrawerSnackbar.severity}
        variant="filled"
        sx={{ width: '100%' }}
      >
        {stateDrawerSnackbar.message}
      </Alert>
    </Snackbar>
  );
};

export default SnackbarAlert;
